import { useTranslation } from "next-i18next";
import { useState } from "react";
import classes from "./StickyFacetsMenu.module.scss";

const PricingFilter = ({ onSelectFilter, selectedValue }: any) => {
  const { t } = useTranslation("common");
  const prevPrices = selectedValue && selectedValue[0]?.includes("custom");
  const [prevLowPrice, prevHighPrice] =
    (prevPrices && selectedValue[0]?.split("custom")) || [];

  const [minPrice, setMinPrice] = useState(prevLowPrice);
  const [maxPrice, setMaxPrice] = useState(prevHighPrice);
  const [errorMsg, setErrorMsg] = useState("");

  const handlePriceFilter = () => {
    if (Number(maxPrice) < Number(minPrice) && Number(maxPrice) > 0) {
      setErrorMsg(`${t("products.error_message")}`);
    } else if (!maxPrice && !minPrice && prevPrices) {
      setErrorMsg("");
      onSelectFilter("price", "custom");
    } else {
      setErrorMsg("");
      onSelectFilter("price", `${minPrice || ""}custom${maxPrice || ""}`);
    }
  };

  const onKeyPressHandler = (key: string) => {
    if ((minPrice || maxPrice || prevPrices) && key === "Enter") {
      handlePriceFilter();
    }
  };

  const handlePriceChange = (price: string, isMinimum: boolean) => {
    if (isNaN(Number(price))) {
      return;
    }
    return isMinimum ? setMinPrice(price) : setMaxPrice(price);
  };

  return (
    <div>
      <div className={classes["facets-menu-price"]}>
        <span className={classes["facets-menu-price_dollar"]}>$</span>
        <input
          type="number"
          onChange={(e) => handlePriceChange(e.target.value, true)}
          data-testid="min-amount"
          maxLength={5}
          min={0}
          placeholder="Min"
          value={minPrice}
          onKeyDown={(e) => onKeyPressHandler(e.key)}
          className={classes["facets-menu-price_input-box"]}
        ></input>
        <div>
          <span className={classes["facets-menu-price_dollar"]}>$</span>
          <input
            type="number"
            onChange={(e) => handlePriceChange(e.target.value, false)}
            data-testid="max-amount"
            maxLength={5}
            min={0}
            placeholder="Max"
            value={maxPrice}
            onKeyDown={(e) => onKeyPressHandler(e.key)}
            className={classes["facets-menu-price_input-box"]}
          ></input>
        </div>
        <button
          className={classes["facets-menu-price_submit"]}
          onClick={handlePriceFilter}
          type="submit"
          disabled={!minPrice && !maxPrice && !prevPrices}
        >
          GO
        </button>
      </div>
      <span className={classes["facets-menu-price_error"]}>{errorMsg}</span>
    </div>
  );
};

export default PricingFilter;
